import { ApolloLink } from '@apollo/client/core';
import { HttpHeaders } from '@angular/common/http';

const authLink = new ApolloLink((operation, forward) => {
  let token: string | null = null;
  const value = localStorage.getItem('access_token');
  try {
    token = JSON.parse(value as string);
  } catch {
    token = null;
  }

  operation.setContext({
    headers: new HttpHeaders({
      Authorization: token ? `Bearer ${token}` : '',
    }),
  });

  return forward(operation);
});

export default authLink;
